export default __webpack_public_path__ + "17b76d2bb2b66fe024d76f02f9a067ed.png";